import { Search, FileText, PenTool, AlertTriangle, FileSearch, Clock } from "lucide-react";

export const navLinks = [
  { label: "Features", href: "#features" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Contact", href: "#contact" },
];

export const painPoints = [
  {
    id: 1,
    icon: AlertTriangle,
    title: "Tracking is a nightmare",
    description:
      "Staying updated and identifying relevant tenders from thousands of listings is overwhelming. By the time you find the right one, the deadline has often passed.",
  },
  {
    id: 2,
    icon: FileSearch,
    title: "Documents are dense & complex",
    description:
      "Tenders come with intricate qualification criteria, technical requirements, and compliance checklists buried in hundreds of pages of documentation.",
  },
  {
    id: 3,
    icon: Clock,
    title: "Bid writing is manual & slow",
    description:
      "Drafting tender responses is tedious, error-prone, and eats up resources that should go toward actually delivering projects.",
  },
];

export const features = [
  {
    id: 1,
    icon: Search,
    title: "Smart Tender Search",
    description:
      "Find relevant tenders instantly. We monitor government portals daily so you don't have to. Filter by industry, location, value, and deadline. Get email alerts for new matches.",
    highlights: ["Daily Monitoring", "Smart Filters", "Email Alerts"],
  },
  {
    id: 2,
    icon: FileText,
    title: "AI Tender Analysis",
    description:
      "Upload any tender document and get an instant structured breakdown: eligibility criteria, key dates, technical requirements, and a Product Match Score showing how well your offerings align.",
    highlights: ["Instant Breakdown", "Eligibility Check", "Match Score"],
  },
  {
    id: 3,
    icon: PenTool,
    title: "AI Bid Builder",
    description:
      "Draft professional bid documents with an AI-powered editor. Select your products, and our assistant generates compliant technical responses, compliance statements, and cover letters, all backed by your actual product specs.",
    highlights: ["AI Editor", "Compliance Ready", "Product-Backed"],
  },
];

export const steps = [
  {
    id: 1,
    number: "01",
    title: "Search",
    description:
      "Enter keywords, get matching government tenders from multiple portals, updated daily.",
  },
  {
    id: 2,
    number: "02",
    title: "Analyze",
    description:
      "AI reads every document and gives you a clear summary + product match score to prioritize your efforts.",
  },
  {
    id: 3,
    number: "03",
    title: "Build & Submit",
    description:
      "Draft your bid with AI assistance, export as PDF/DOCX, and submit with confidence.",
  },
];

